import type { OnInit } from '@angular/core';
import { Component, ElementRef, forwardRef, Input, Renderer2 } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseSelectFormFieldComponent } from '@shared/form-fields/select/base-select-form-field.component';
import { ApiParams } from '@shared/http/api-params';
import type { Team } from '@shared/modules/teams/team';
import { TeamFetcher } from '@shared/modules/teams/team.fetcher';
import { allTeamsOption } from '@shared/services/selected-teams/constants';

@Component({
    selector: 'app-team-select',
    styleUrls: ['./team-select.component.scss'],
    templateUrl: '../../../form-fields/select/select-form-field.component.html',
    providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => TeamSelectComponent), multi: true }],
})
export class TeamSelectComponent extends BaseSelectFormFieldComponent<Team> implements OnInit {
    @Input() showAllTeamsOption = true;
    @Input() params: ApiParams = {};

    constructor(element: ElementRef,
                renderer: Renderer2,
                private fetcher: TeamFetcher) {
        super(element, renderer);
    }

    ngOnInit(): void {
        super.ngOnInit();

        if (this.fetchFromApi) {
            this.fetcher.all({
                ...this.params,
                order_by: 'description',
                direction: 'asc',
            }).subscribe(response => {
                this.apiOptions = [
                    // Make sure we have the option to select 'All Teams'
                    this.showAllTeamsOption ? allTeamsOption : null,
                    ...response.data.map(team => ({
                            label: team.description,
                            value: team
                        }))
                ].filter(Boolean);
            });
        }
    }
}
